export type CancelablePromise = Promise<any> & { cancel: () => void }

export function makeCancelable(promise: Promise<any>): CancelablePromise {
  let hasCanceled_ = false

  const wrappedPromise = new Promise((resolve, reject) => {
    promise.then(val =>
      hasCanceled_ ? reject(new Error('Promise was cancelled')) : resolve(val)
    )
    promise.catch(error =>
      hasCanceled_ ? reject(new Error('Promise was cancelled')) : reject(error)
    )
  })

  return Object.assign(wrappedPromise, {
    cancel: () => {
      hasCanceled_ = true
    },
  })
}
